/*
 * DISTRIBUSI — pure list logic shared by the old screens (distribution.jsx) and the phone view (dist-hp-*.jsx):
 * the customer list's quick chips, delivery gap, sort orders and CSV, and the Transaksi list's filters, summary,
 * day groups and allowed periods. Lifted from DistCustomers / DistTransactions unchanged so both views filter,
 * order and export the same way. Isomorphic; tested in Node. No DOM, no server calls.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;   // tests (CommonJS)
  if (root) root.DLIST = api;                                                  // browser (global)
})(typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : this), function () {
  'use strict';

  // Delivery gap = days since the last WATER delivery, from the server; null when it withheld the gap
  // (view window shorter than 14 days), for an inactive customer, or when there is none.
  function custGapDays(c, o) {
    if (!(o && o.gapOk) || !c || c.active === false || c.deliveryGapDays == null) return null;
    return c.deliveryGapDays;
  }
  var isGap = function (c, n, o) { var g = custGapDays(c, o); return g != null && g >= n; };

  // chip: all | bon | galon | reguler | bulk | belum | gap7 | gap14 (anything else passes)
  function custChipPass(c, chip, o) {
    return chip === 'all' ? true
      : chip === 'bon' ? c.sisaBon > 0
      : chip === 'galon' ? (c.gallonsHeld || 0) > 0
      : chip === 'bulk' ? c.type === 'bulk'
      : chip === 'reguler' ? c.type === 'reguler'
      : chip === 'belum' ? c.complete === false
      : chip === 'gap7' ? isGap(c, 7, o)
      : chip === 'gap14' ? isGap(c, 14, o) : true;
  }

  var byName = function (a, b) { return String(a.name || '').localeCompare(String(b.name || ''), 'id'); };
  var CMP = {
    nama: byName,
    bon: function (a, b) { return (b.sisaBon || 0) - (a.sisaBon || 0) || byName(a, b); },
    // Smallest bon first among customers who still owe; the fully paid ones sink to the bottom so a
    // wall of "Lunas" never fills the top of the list.
    bonAsc: function (a, b) { return ((a.sisaBon || 0) > 0 ? 0 : 1) - ((b.sisaBon || 0) > 0 ? 0 : 1) || (a.sisaBon || 0) - (b.sisaBon || 0) || byName(a, b); },
    last: function (a, b) { return String(b.lastDate || '').localeCompare(String(a.lastDate || '')) || byName(a, b); },
    lastAsc: function (a, b) { return String(a.lastDate || '').localeCompare(String(b.lastDate || '')) || byName(a, b); },   // never-transacted ('') first
    spend: function (a, b) { return (b.spend || 0) - (a.spend || 0) || byName(a, b); },
    gap: function (a, b) { return (b.deliveryGapDays || 0) - (a.deliveryGapDays || 0) || byName(a, b); },
  };
  // key: nama | bon | bonAsc | last | lastAsc | spend | gap (unknown → nama). Returns a new array.
  function custSort(list, key) { return (list || []).slice().sort(CMP[key] || CMP.nama); }

  // The current filter (every matching row, not just the rendered window) as CSV: CRLF lines, a cell with a
  // quote, comma or newline is quoted with its quotes doubled.
  function custCsv(list, o) {
    var tr = o.tr; var typeLabelOf = o.typeLabelOf; var fmtDays = o.fmtDays;
    var head = [tr('cl.colCode'), tr('cl.colName'), tr('cl.colPhone'), tr('cl.colType'), tr('cl.colArmada'), tr('cl.colDays'), tr('cl.colBon'), tr('cl.colGalon'), tr('cl.colLast'), tr('cl.colSpend')];
    var body = (list || []).map(function (c) { return [c.code || '', c.name || '', c.phone || '', typeLabelOf(c.type), c.armada || '', fmtDays(c.deliveryDays) || '', c.sisaBon || 0, c.gallonsHeld || 0, c.lastDate || '', c.spend || 0]; });
    var cell = function (c) { return /[",\n]/.test(String(c)) ? '"' + String(c).replace(/"/g, '""') + '"' : c; };
    return [head].concat(body).map(function (row) { return row.map(cell).join(','); }).join('\r\n');
  }

  // Customer-detail period chips → { from, to } (inclusive ISO dates) or null for "all" / an unfinished range.
  // period: all | 30 | month | lastMonth | year | range | YYYY-MM (a picked month). Same bounds as the old Transaksi tab.
  var isoAdd = function (iso, n) { var d = new Date(iso + 'T00:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
  function txPeriod(period, today, from, to) {
    if (period === '30') return { from: isoAdd(today, -29), to: today };
    if (period === 'month') return { from: today.slice(0, 8) + '01', to: today };
    if (period === 'lastMonth') { var first = today.slice(0, 8) + '01'; var end = isoAdd(first, -1); return { from: end.slice(0, 8) + '01', to: end }; }
    if (period === 'year') return { from: today.slice(0, 4) + '-01-01', to: today };
    if (period === 'range') return (from && to) ? { from: from, to: to } : null;
    if (/^\d{4}-\d{2}$/.test(period || '')) { var nx = isoAdd(period + '-28', 4).slice(0, 8) + '01'; return { from: period + '-01', to: isoAdd(nx, -1) }; }
    return null;
  }
  // The months that have transactions (YYYY-MM), newest first — the "Pilih bulan" list.
  function txMonths(txns) {
    var seen = {};
    (txns || []).forEach(function (t) { var k = /^\d{4}-\d{2}/.test(t.txnDate || '') ? t.txnDate.slice(0, 7) : ''; if (k) seen[k] = 1; });
    return Object.keys(seen).sort().reverse();
  }

  // The signed receivable effect of one row on Sisa Bon: bon +, pelunasan −, a void / uncounted row 0, a
  // deducting dispute (tidak_diakui / kerugian) carved out. Mirrors the server's customerBonBalance.
  var txVoid = function (t) { return !!(t.voided || t.status === 'void'); };
  function txBonEffect(t) {
    if (txVoid(t) || !t.bonCounted) return 0;
    if (t.method === 'bon') {
      var e = t.effectiveAmount != null ? t.effectiveAmount : t.amount;
      var d = t.dispute;
      if (d && d.deducts && (d.status === 'tidak_diakui' || d.status === 'kerugian')) e -= (d.disputedAmount || 0);
      return Math.max(0, e);
    }
    if (t.method === 'pelunasan') return -t.amount;
    return 0;
  }
  // An approved bon adjustment's date (WITA), for placing it before/inside/after a period.
  var adjDate = function (a) { var ms = a.approvedAt || a.createdAt; return ms ? new Date(ms + 8 * 3600000).toISOString().slice(0, 10) : ''; };

  // Customer-detail TOTAL TRANSAKSI over the period bounds `pb` (null = all time):
  //   lunas / bon     — water sales (not ganti rugi, not a saldo-awal row), effective amount + gallons
  //   bayar           — pelunasan received;  gantiRugi — gallon compensation charged;  void rows never count
  //   archive false   — imported (legacy) rows leave the buckets
  // recon reconciles the REAL balance, so it ignores the archive switch and is anchored on the server's unfloored
  // balance (sisaBonRaw): akhir = raw − everything after the period, awal = raw − everything from its start, and
  // lain = what moved the balance besides bon / ganti rugi / bayar (saldo awal, penyesuaian, sengketa).
  // A negative akhir is lebih bayar. No raw balance (hidden for this caller) → recon null.
  function custTotals(txns, o) {
    o = o || {};
    var pb = o.pb || null, arch = o.archive !== false;
    var inP = function (t) { return !pb || ((t.txnDate || '') >= pb.from && (t.txnDate || '') <= pb.to); };
    var s = { lunas: { rp: 0, galon: 0, n: 0 }, bon: { rp: 0, galon: 0, n: 0 }, bayar: { rp: 0, n: 0 }, gantiRugi: { rp: 0, galon: 0, n: 0 }, total: { rp: 0, galon: 0, n: 0 }, recon: null };
    var r = { awal: 0, bon: 0, gantiRugi: 0, bayar: 0, lain: 0, akhir: 0 };
    var shiftFrom = 0, shiftAfter = 0;
    (txns || []).forEach(function (t) {
      var d = t.txnDate || '', eff = txBonEffect(t);
      if (pb && d >= pb.from) shiftFrom += eff;
      if (pb && d > pb.to) shiftAfter += eff;
      if (txVoid(t) || !inP(t)) return;
      var a = amtOf(t), gr = t.kind === 'ganti_rugi', sale = !gr && !t.openingBon && (t.method === 'lunas' || t.method === 'bon');
      if (t.bonCounted) {
        if (sale && t.method === 'bon') r.bon += a;
        else if (gr && t.method === 'bon') r.gantiRugi += a;
        else if (t.method === 'pelunasan') r.bayar += t.amount;
      }
      if (!arch && t.legacy) return;
      if (sale) { var b = s[t.method]; b.rp += a; b.galon += t.qty || 0; b.n++; }
      else if (gr) { s.gantiRugi.rp += a; s.gantiRugi.galon += t.gallonQty || 0; s.gantiRugi.n++; }
      else if (t.method === 'pelunasan') { s.bayar.rp += t.amount; s.bayar.n++; }
    });
    s.total = { rp: s.lunas.rp + s.bon.rp, galon: s.lunas.galon + s.bon.galon, n: s.lunas.n + s.bon.n };
    if (o.sisaBonRaw == null) return s;
    (o.adjustments || []).forEach(function (x) {
      if (x.kind !== 'bon' || x.status !== 'approved') return;
      var d = adjDate(x);
      if (pb && d >= pb.from) shiftFrom += x.delta;
      if (pb && d > pb.to) shiftAfter += x.delta;
    });
    r.akhir = o.sisaBonRaw - shiftAfter;
    r.awal = pb ? o.sisaBonRaw - shiftFrom : 0;
    r.lain = r.akhir - r.awal - r.bon - r.gantiRugi + r.bayar;
    s.recon = r;
    return s;
  }

  // Customer-detail search: the transaction code (passed in — it is built by the screen), note, amount, the
  // effective amount and the import batch, case-insensitive. An empty query matches everything.
  function txSearch(t, q, code) {
    var s = String(q || '').trim().toLowerCase();
    if (!s) return true;
    return [code, t.note, String(t.amount), String(t.effectiveAmount != null ? t.effectiveAmount : ''), t.importBatchId].some(function (x) { return String(x || '').toLowerCase().indexOf(s) >= 0; });
  }
  // Multi-select (Koreksi / Hapus massal): a billed row is locked; one awaiting approval cannot be picked;
  // koreksi also skips voided and ganti rugi rows (the server refuses them too).
  function txPickable(t, mode) {
    if (mode === 'hapus') return !t.pendingRequest && !t.invoiceNo;
    return !t.voided && !t.pendingRequest && t.kind !== 'ganti_rugi' && !t.invoiceNo;
  }

  // Add / Edit customer form state: null → a new customer of type defType; a customer → its values (a partial
  // or junk reminder becomes a complete one, off unless enabled).
  var REM0 = function () { return { enabled: false, dueDay: 0, weekday: '', overdueDays: 0, gallonThreshold: 0, bonThreshold: 0 }; };
  function custFormInit(d, defType) {
    if (!d) return { id: null, name: '', phone: '', type: defType, price: '', deliveryDays: [], armada: '', reminder: REM0(), address: '', mapsUrl: '', fixedDays: false };
    var r = d.reminder;
    return { id: d.id, name: d.name || '', phone: d.phone || '', type: d.type || defType, price: '', deliveryDays: Array.isArray(d.deliveryDays) ? d.deliveryDays : [], armada: d.armada || '',
      reminder: (r && typeof r === 'object') ? Object.assign(REM0(), r, { enabled: !!r.enabled }) : REM0(), address: d.address || '', mapsUrl: d.mapsUrl || '', fixedDays: !!d.fixedDays };
  }

  // Add / Edit customer: the body for customers.create (no id: needs masterPrice) or customers.update (id: the
  // price is changed in Harga Master only), or { err: <i18n key> } — refused in this order: name, maps link,
  // fixed days without a day, price. A GPS-captured point (_lat/_lng) also sends lat/lng/accuracy.
  function custFormBody(f) {
    var name = String(f.name || '').trim();
    if (!name) return { err: 'dist.cfNameReq' };
    var mu = String(f.mapsUrl || '').trim();
    if (mu && !/^https?:\/\//i.test(mu)) return { err: 'dist.mapsUrlInvalid' };
    if (f.fixedDays && !(f.deliveryDays || []).length) return { err: 'cust.fixedNeedDay' };
    var loc = { address: String(f.address || '').trim(), mapsUrl: mu };
    if (f._lat != null && f._lng != null) { loc.lat = f._lat; loc.lng = f._lng; loc.accuracy = f._accuracy != null ? f._accuracy : null; }
    var phone = String(f.phone || '').trim();
    if (f.id) return { body: Object.assign({ name: name, phone: phone, type: f.type, deliveryDays: f.deliveryDays, armada: f.armada, reminder: f.reminder, fixedDays: !!f.fixedDays }, loc) };
    var price = parseInt(String(f.price == null ? '' : f.price).replace(/[^0-9]/g, ''), 10);
    if (!price) return { err: 'dist.cfPriceReq' };
    return { body: Object.assign({ name: name, phone: phone, type: f.type, masterPrice: price, deliveryDays: f.deliveryDays, armada: f.armada, reminder: f.reminder, fixedDays: !!f.fixedDays }, loc) };
  }

  // ── Daftar Transaksi (DistTransactions + DhpTransactions) ──
  var amtOf = function (t) { return t.effectiveAmount != null ? t.effectiveAmount : t.amount; };
  var digits = function (v) { return v ? (parseInt(String(v).replace(/\D/g, ''), 10) || 0) : null; };
  // A list row's status: dibatalkan | tidak_diakui | kerugian | disengketakan | terkunci (awaiting approval) | normal.
  function txStatusKey(t) {
    var ds = t.dispute && t.dispute.status;
    return t.status === 'void' ? 'dibatalkan'
      : ds === 'tidak_diakui' ? 'tidak_diakui'
        : ds === 'kerugian' ? 'kerugian'
          : ds === 'disengketakan' ? 'disengketakan'
            : t.pendingRequest ? 'terkunci' : 'normal';
  }
  // An expense (DistExpense) shaped like a transaction so the one list pipeline can carry it; _exp marks it.
  function txnExpRow(e) {
    return { _exp: true, expId: e.id, id: 'exp_' + e.id, method: 'pengeluaran', txnDate: e.date, amount: e.amount, effectiveAmount: e.amount, category: e.category, note: e.note || '', recipient: e.recipient || '', expMethod: e.method || 'tunai', fleetId: e.fleetId || '', actorName: e.createdByName || '', createdAt: e.createdAt || 0, status: e.status, photoId: e.photoId || null, legacy: false, corrections: [] };
  }
  // Search: a transaction by code, customer name / code / phone (o, from the screen), effective amount, note; an
  // expense by its category label (o.catLabel), category, recipient, note, amount. Empty matches everything.
  function txnMatch(t, q, o) {
    if (!q) return true;
    var s = String(q).toLowerCase(); o = o || {};
    var f = t._exp ? [o.catLabel, t.category, t.recipient, t.note, String(t.amount)] : [o.code, o.name, o.custCode, o.phone, String(amtOf(t)), t.note];
    return f.some(function (v) { return String(v || '').toLowerCase().indexOf(s) >= 0; });
  }
  // sel: { methods, statuses, sources, armada, petugas: string[] (empty = any), tfWait, adv: { min, max (digits in
  // any format), customer, note, corrected } }. An expense joins only the filters that mean something for it.
  function txnPass(t, sel) {
    var has = function (a, v) { return !(a && a.length) || a.indexOf(v) >= 0; };
    var adv = sel.adv || {}; var minN = digits(adv.min); var maxN = digits(adv.max);
    if (t._exp) {
      if (!has(sel.methods, 'pengeluaran')) return false;
      if (!has(sel.statuses, t.status === 'void' ? 'dibatalkan' : 'normal')) return false;
      if (!has(sel.sources, 'manual')) return false;
      if (!has(sel.armada, t.fleetId || '')) return false;
      if (!has(sel.petugas, t.actorName || '')) return false;
      if (adv.customer) return false;   // an expense has no customer
      if (minN != null && t.amount < minN) return false;
      if (maxN != null && t.amount > maxN) return false;
      if (adv.note && !(t.note && String(t.note).trim())) return false;
      if (adv.corrected) return false;
      if (sel.tfWait) return false;     // an expense is never a ganti rugi
      return true;
    }
    if ((sel.methods || []).length && !(sel.methods.indexOf(t.method) >= 0 || (t.adjusted && sel.methods.indexOf('penyesuaian') >= 0))) return false;
    if (!has(sel.statuses, txStatusKey(t))) return false;
    if (!has(sel.sources, t.legacy ? 'impor' : 'manual')) return false;
    if (!has(sel.armada, t.fleetId || '')) return false;
    if (!has(sel.petugas, t.actorName || '')) return false;
    if (adv.customer && t.customerId !== adv.customer) return false;
    if (minN != null && amtOf(t) < minN) return false;
    if (maxN != null && amtOf(t) > maxN) return false;
    if (adv.note && !(t.note && String(t.note).trim())) return false;
    if (adv.corrected && !((t.corrections || []).length)) return false;
    if (sel.tfWait && !t.transferAwaiting) return false;
    return true;
  }
  // Summary over a filtered set: sales (nominal) = lunas + bon at the effective amount; galon = gallons in the listed
  // txns (archive rows too — a txn count, not stock), pelunasan skipped; voided rows count nowhere; expenses apart.
  function txnSummary(rows) {
    var s = { count: 0, galon: 0, nominal: 0, lunas: 0, bon: 0, nLunas: 0, nBon: 0, expense: 0, avg: 0 };
    (rows || []).forEach(function (t) {
      if (t._exp) { if (t.status !== 'void') s.expense += t.amount; return; }
      if (t.status === 'void') return;
      s.count++;
      if (t.method !== 'pelunasan') s.galon += t.qty || 0;
      var a = amtOf(t);
      if (t.method === 'lunas') { s.nominal += a; s.lunas += a; s.nLunas++; } else if (t.method === 'bon') { s.nominal += a; s.bon += a; s.nBon++; }
    });
    s.avg = s.count ? Math.round(s.nominal / s.count) : 0;
    return s;
  }
  // Day groups in row order, each with its subtotal: nota (not voided), galon (no pelunasan; archive counts), nominal
  // (everything but pelunasan), expense.
  function txnDayGroups(rows) {
    var out = []; var gm = {};
    (rows || []).forEach(function (t) {
      var k = t.txnDate || '—';
      if (!gm[k]) { gm[k] = { date: k, rows: [], nota: 0, galon: 0, nominal: 0, expense: 0 }; out.push(gm[k]); }
      var g = gm[k]; g.rows.push(t);
      if (t._exp) { if (t.status !== 'void') g.expense += t.amount; } else if (t.status !== 'void') { g.nota++; if (t.method !== 'pelunasan') g.galon += t.qty || 0; g.nominal += (t.method === 'pelunasan' ? 0 : amtOf(t)); }
    });
    return out;
  }
  // Chip counts over the searched set (stable while chips are toggled): txns and exps already match the search.
  // pengeluaran counts non-voided expenses; armada / petugas list each value once (petugas at most 40).
  function txnFacets(txns, exps) {
    var f = { method: { lunas: 0, bon: 0, pelunasan: 0, penyesuaian: 0, pengeluaran: (exps || []).filter(function (e) { return e.status !== 'void'; }).length },
      status: { normal: 0, terkunci: 0, disengketakan: 0, tidak_diakui: 0, kerugian: 0, dibatalkan: 0 }, source: { manual: 0, impor: 0 }, armada: [], petugas: [] };
    (txns || []).forEach(function (t) {
      if (f.method[t.method] != null) f.method[t.method]++;
      if (t.adjusted) f.method.penyesuaian++;
      f.status[txStatusKey(t)]++;
      f.source[t.legacy ? 'impor' : 'manual']++;
      if (t.fleetId && f.armada.indexOf(t.fleetId) < 0) f.armada.push(t.fleetId);
      if (t.actorName && f.petugas.indexOf(t.actorName) < 0) f.petugas.push(t.actorName);
    });
    f.petugas = f.petugas.slice(0, 40);
    return f;
  }
  // A period preset is offered only when its whole range fits the user's view window (mirror of the server's
  // viewWindowFrom — convenience, the server still enforces). lastMonth / range need full history. Never 'all'.
  function txnPeriodAllowed(k, o) {
    if (k === 'all') return false;
    if (o.canViewAll) return true;
    if (k === 'lastMonth' || k === 'range') return false;
    var today = o.today; var f = today;
    var earlier = function (d) { if (d && d < f) f = d; };
    if (o.canView7) earlier(isoAdd(today, -6));
    if (o.canViewMonth) earlier(today.slice(0, 8) + '01');
    if (o.maxLookback > 0) earlier(isoAdd(today, -o.maxLookback));
    var start = { today: today, week: isoAdd(today, -6), month: today.slice(0, 8) + '01' }[k];
    return start != null && start >= f;
  }

  return { custChipPass: custChipPass, custGapDays: custGapDays, custSort: custSort, custCsv: custCsv, txPeriod: txPeriod, txMonths: txMonths, txBonEffect: txBonEffect, custTotals: custTotals, txSearch: txSearch, txPickable: txPickable, custFormInit: custFormInit, custFormBody: custFormBody,
    txStatusKey: txStatusKey, txnExpRow: txnExpRow, txnMatch: txnMatch, txnPass: txnPass, txnSummary: txnSummary, txnDayGroups: txnDayGroups, txnPeriodAllowed: txnPeriodAllowed, txnFacets: txnFacets };
});
